/* eslint-disable react/prop-types */
import { PersonAdd } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useRecoilState } from "recoil";
import { AlertState } from "states";
import CustomFieldForm from "../../components/CustomFieldForm";
import CustomTabPanel from "../../components/CustomPanel/customPanel";
import { API_ROUTES, CODE_QUANGNAM } from "../../utils/constants";
import { JsonTool } from "../../utils/jsonTools";

const defaultValue = {
  ma: "",
  ten: "",
  email: "",
  dienthoai: "",
  diachi: "",
  maphuong: null,
  maquan: null,
  matinh: CODE_QUANGNAM,
  loaihinh: null,
  ngaycap: null,
  coquancap: "",
  nguoidaidienphapluat: "",
  nguoidaidienphapluat_email: "",
  nguoidaidienphapluat_diachi: "",
  nguoidaidienphapluat_dienthoai: "",
  nguoidaidienphapluat_chucvu: "",
  gioitinh: "M",
  quocgia: 1,
  ngaysinh: null,
  dantoc: 1,
  socccd: "",
  ngaycap_cccd: null,
  noicap_cccd: "",
  ghichu: "",
  solaodongquanly: 0,
  solaodongsanxuat: 0,
  trangthai: 1,
  first_name: "",
  last_name: "",
  username: "",
  password: "",
  repassword: "",
  birth_date: null,
  is_active: false,
  gender: "M",
  address: "",
  donvi: "",
};

const optionGioiTinh = [
  {
    id: "M",
    ten: "Nam",
  },
  {
    id: "F",
    ten: "Nữ",
  },
  {
    id: "O",
    ten: "Khác",
  },
];

const FormDangKyChuThe = ({
  //   onClose,
  onSubmit,
  dataDantoc,
  dataQuocgia,
  dataTinh,
  dataLoai,
  dataTrangThai,
}) => {
  // state lỗi giá trị từ form
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);

  //new state
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionSubDitrict, setOptionSubDitrict] = useState([]);
  const [value, setValue] = useState(0);
  const [alert, setAlert] = useRecoilState(AlertState);
  const [isShowPass, setIsShowPass] = useState(false);
  const [isShowRePass, setIsShowRePass] = useState(false);

  //change
  const handleChangeProvince = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        matinh: value,
        maquan: "",
        maphuong: "",
      };
    });
    getDistrict(value);
  };
  const handleChangeDistrict = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        maquan: value,
        maphuong: "",
      };
    });
    getSubditrict(value);
  };

  const fieldSign01 = useMemo(() => {
    let result = [
      {
        name: "Họ",
        key: "first_name",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Tên",
        key: "last_name",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Tài khoản",
        key: "username",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Email",
        key: "email",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 3,
      },
    ];
    return result;
  }, []);

  const fieldSign02 = useMemo(() => {
    const result = [
      {
        name: "Tỉnh thành",
        key: "matinh",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "ma",
        labelKeyOption: "ten",
        onChange: handleChangeProvince,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Quận/Huyện",
        key: "maquan",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "ma",
        labelKeyOption: "ten",
        onChange: handleChangeDistrict,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Phường/Xã",
        key: "maphuong",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "ma",
        labelKeyOption: "ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Địa chỉ",
        key: "address",
        type: "text",
        required: true,
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 6,
      },
      {
        name: "Ngày sinh",
        key: "birth_date",
        type: "date",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Giới tính",
        key: "gender",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 3,
      },
    ];
    return result;
  }, []);

  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Mã/số đăng ký kinh doanh",
        key: "ma",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Tên chủ thể",
        key: "ten",
        type: "text",
        required: true,
        maxLength: 1000,
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Loại hình tổ chức",
        key: "loaihinh",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số điện thoại",
        key: "dienthoai",
        type: "text",
        maxLength: 150,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày cấp",
        key: "ngaycap",
        type: "date",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Cơ quan cấp",
        key: "coquancap",
        type: "text",
        maxLength: 225,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Số lao động quản lý",
        key: "solaodongquanly",
        type: "number",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số lao động sản xuất",
        key: "solaodongsanxuat",
        type: "number",
        xs: 6,
        md: 4,
        lg: 4,
      },
      {
        name: "Trạng thái",
        key: "trangthai",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 6,
        md: 4,
        lg: 4,
      },
      {
        name: "Ghi chú",
        key: "ghichu",
        type: "textArea",
        maxLength: 500,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);

  const fieldNguoiDaiDien = useMemo(() => {
    let result = [
      {
        name: "Người đại diện pháp luật",
        key: "nguoidaidienphapluat",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Email người đại diện",
        key: "nguoidaidienphapluat_email",
        type: "text",
        maxLength: 50,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Địa chỉ người đại diện",
        key: "nguoidaidienphapluat_diachi",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số điện thoại người đại diện",
        key: "nguoidaidienphapluat_dienthoai",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Chức vụ",
        key: "nguoidaidienphapluat_chucvu",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Giới tính",
        key: "gioitinh",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Quốc gia",
        key: "quocgia",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Dân tộc",
        key: "dantoc",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Ngày sinh",
        key: "ngaysinh",
        type: "date",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Số CCCD/Hộ chiếu",
        key: "socccd",
        type: "text",
        maxLength: 100,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày cấp",
        key: "ngaycap_cccd",
        type: "date",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Nơi cấp",
        key: "noicap_cccd",
        type: "text",
        maxLength: 100,
        xs: 12,
        md: 4,
        lg: 4,
      },
    ];
    return result;
  }, []);

  const getDistrict = (code, disCode) => {
    axios
      .get(API_ROUTES.GETHUYEN, { params: { tinh: code } })
      .then((res) => {
        setOptionDistrict(res?.data);
        setOptionSubDitrict([]);
        if (disCode) {
          getSubditrict(disCode);
        }
      })
      .catch(() => {});
  };
  const getSubditrict = (code, list) => {
    axios
      .get(API_ROUTES.GETXA, { params: { huyen: code } })
      .then((res) => {
        setOptionSubDitrict(res?.data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getDistrict(CODE_QUANGNAM);
  }, []);
  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    const listFormatDate = [
      "ngaycap",
      "birth_date",
      "ngaycap_cccd",
      "ngaysinh",
    ];
    listFormatDate?.forEach((field) => {
      _data[field] =
        dataState?.[field] &&
        !errors?.[field] &&
        dayjs(dataState?.[field])?.isValid()
          ? dayjs(dataState?.[field]).format("YYYY-MM-DD")
          : null;
    });
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      setAlert({
        alert: true,
        message: "Thông tin nhập bị lỗi, vui lòng kiểm tra lại!",
        type: "error",
      });
      return;
    }
    _data["diachi"] = _data?.address;
    if (
      _data["nguoidaidienphapluat"] == "" ||
      _data["nguoidaidienphapluat"] == null ||
      _data["nguoidaidienphapluat"] == undefined
    ) {
      _data["nguoidaidienphapluat"] =
        _data?.first_name + " " + _data?.last_name;
    }
    onSubmit(_data);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handlePassVisibilty = () => {
    setIsShowPass((prev) => !prev);
  };
  const handleRePassVisibilty = () => {
    setIsShowRePass((prev) => !prev);
  };
  const handleChangeValueInput = (key) => (e) => {
    const { value } = e?.target;
    setDataState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  return (
    <>
      <div className="flex flex-col overflow-hidden flex-1 max-w-[1000px] m-auto">
        <div className="py-3 flex justify-center items-center">
          <Box
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              borderColor: "divider",
              padding: "0 1rem 1rem 1rem",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              aria-label="basic tabs example"
            >
              <Tab
                icon={<AccountCircleIcon />}
                label="Đăng ký"
                {...JsonTool.a11yProps(0)}
              />
              <Tab
                icon={<BusinessIcon />}
                label="Thông tin chủ thể"
                {...JsonTool.a11yProps(1)}
              />
            </Tabs>
          </Box>
        </div>
        <div className="overflow-auto flex-1">
          {/* show lỗi từ khi không xác định được từ các field ở form */}
          {errors && errors.error ? (
            <Grid container sx={{ textAlign: "center", mb: 0 }}>
              <Grid item xs={12}>
                <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                  {errors.error}
                </Alert>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
          <CustomTabPanel value={value} index={0}>
            {fieldSign01?.length > 0 && (
              <CustomFieldForm
                key={"fieldSign_01"}
                listField={fieldSign01}
                data={dataState}
                onChange={handleChangeDataState}
                onError={handleErrorDataState}
                errorValues={errors}
                listOptionDic={{}}
              />
            )}
            <Grid
              container
              spacing={2}
              sx={{ textAlign: "left", marginTop: "0" }}
            >
              <Grid item xs={6} md={6} lg={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Mật khẩu <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  type={isShowPass ? "text" : "password"}
                  name="password"
                  error={errors ? !!errors.password : false}
                  helperText={errors?.password}
                  value={
                    dataState && dataState.password ? dataState.password : ""
                  }
                  onChange={handleChangeValueInput("password")}
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      password: "",
                    });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handlePassVisibilty}
                          aria-label="toggle password"
                          edge="end"
                        >
                          {isShowPass ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Xác nhận lại Mật khẩu <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  type={isShowRePass ? "text" : "password"}
                  name="repassword"
                  error={errors ? !!errors.repassword : false}
                  helperText={errors?.repassword}
                  value={
                    dataState && dataState.repassword
                      ? dataState.repassword
                      : ""
                  }
                  onChange={handleChangeValueInput("repassword")}
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      repassword: "",
                    });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleRePassVisibilty}
                          aria-label="toggle password"
                          edge="end"
                        >
                          {isShowRePass ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <div className="mt-2 lg:mt-4">
              {fieldSign02?.length > 0 && (
                <CustomFieldForm
                  key={"fieldSign_02"}
                  listField={fieldSign02}
                  data={dataState}
                  onChange={handleChangeDataState}
                  onError={handleErrorDataState}
                  errorValues={errors}
                  listOptionDic={{
                    matinh: dataTinh,
                    maquan: optionDistrict,
                    maphuong: optionSubDitrict,
                    gender: optionGioiTinh,
                  }}
                />
              )}
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {fieldInfor?.length > 0 && (
              <CustomFieldForm
                key={"fieldInfor"}
                listField={fieldInfor}
                data={dataState}
                onChange={handleChangeDataState}
                onError={handleErrorDataState}
                errorValues={errors}
                listOptionDic={{
                  loaihinh: dataLoai,
                  trangthai: dataTrangThai,
                }}
              />
            )}
            <Accordion
              style={{ marginTop: "1rem", marginBottom: "1rem" }}
              defaultExpanded={true}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{
                  backgroundColor: "#e3eeff",
                }}
              >
                <Typography fontSize={"1rem"} fontWeight={600}>
                  Thông tin người đại diện
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {fieldNguoiDaiDien?.length > 0 && (
                  <CustomFieldForm
                    key={"fieldNguoiDaiDien"}
                    listField={fieldNguoiDaiDien}
                    data={dataState}
                    onChange={handleChangeDataState}
                    onError={handleErrorDataState}
                    errorValues={errors}
                    listOptionDic={{
                      quocgia: dataQuocgia,
                      dantoc: dataDantoc,
                      gioitinh: optionGioiTinh,
                    }}
                  />
                )}
              </AccordionDetails>
            </Accordion>
          </CustomTabPanel>
        </div>

        <div className="py-3 flex justify-center items-center">
          <MDButton
            color="primary"
            type="submit"
            variant="contained"
            startIcon={<PersonAdd />}
            onClick={onSubmitForm}
          >
            Đăng ký
          </MDButton>
        </div>
      </div>
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

const validMail = (value, name) => {
  let result = false;
  if (value && JsonTool.validateEmail(value)) {
    result = true;
  }
  return result;
};

function validateOBJ(dkct) {
  let result = {
    ma: !validateRequired(dkct.ma) ? "Mã không được trống" : "",
    first_name: !validateRequired(dkct.first_name) ? "Họ không được trống" : "",
    last_name: !validateRequired(dkct.last_name) ? "Tên không được trống" : "",
    ten: !validateRequired(dkct.ten) ? "Tên chủ thể không được trống" : "",
    username: !validateRequired(dkct.username)
      ? "Tên đăng nhập không được trống"
      : "",
    password: !validateRequired(dkct.password)
      ? "Mật khẩu không được trống"
      : "",
    repassword: !validateRequired(dkct.repassword)
      ? "Mật khẩu nhập lại không được trống"
      : "",
    gender: !validateRequired(dkct.gender) ? "Chọn giới tính" : "",
    address: !validateRequired(dkct.address) ? "Địa chỉ không được trống" : "",
    matinh: !validateRequired(dkct.matinh) ? "Chọn Tỉnh thành" : "",
    maphuong: !validateRequired(dkct.maphuong) ? "Chọn Phường/Xã" : "",
    maquan: !validateRequired(dkct.maquan) ? "Chọn Quận/Quyện" : "",
    ten: !validateRequired(dkct.ten) ? "Tên chủ thể không được trống" : "",
    email: !validateRequired(dkct.email)
      ? "Email không được trống"
      : validMail(dkct.email)
      ? "Định dạng Email không đúng"
      : "",
    nguoidaidienphapluat_email: dkct?.nguoidaidienphapluat_email
      ? validMail(dkct.nguoidaidienphapluat_email)
        ? "Định dạng Email không đúng"
        : ""
      : "",
    quocgia: !validateRequired(dkct.quocgia) ? "Chọn Quốc gia" : "",
    dantoc: !validateRequired(dkct.dantoc) ? "Chọn Dân tộc" : "",
    ngaycap: !validateRequired(dkct.ngaycap)
      ? "Ngày cấp trống hoặc sai định dạng"
      : "",
    loaihinh: !validateRequired(dkct.loaihinh) ? "Chọn Loại hình tổ chức" : "",
    gioitinh: !validateRequired(dkct.gioitinh) ? "Chọn giới tính" : "",
    trangthai: !validateRequired(dkct.trangthai) ? "Chọn Trạng thái" : "",
  };
  return result;
}
export default FormDangKyChuThe;
